<template>
  <div class="kingdom">
    <section class="main">
      <div class="t_pic_box">
        <img
          class="t_pic"
          src="../assets/img/join/join-02-3.png"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-03.jpg"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-04.jpg"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-05.jpg"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-06.jpg"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-07.jpg"
          alt="粒上皇加盟"
        />
        <img
          class="t_pic"
          src="../assets/img/join/join-08.jpg"
          alt="粒上皇加盟"
        />
      </div>
    </section>
    <el-dialog
      title="关于粒上皇招商加盟的特别声明"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="dialog-content">
        <p>
          自2020年粒上皇开放特许经营业务以来，受到广大投资者、创业者的关注和欢迎，同时我们注意到，部分不法分子假冒“粒上皇”品牌，或以粒上皇总部、分公司、招商部等名义发布相关加盟的虚假信息，严重损害粒上皇及投资者、创业者合法权益。
        </p>
        <p>现郑重声明如下：</p>
        <p></p>
        <p>
          1.粒上皇加盟申请官方渠道仅有4处：粒上皇官网（www.lishanghuang.com）、粒上皇加盟公众号（粒上皇官方加盟）、粒上皇抖音号（粒上皇官方加盟ID：LSHGFJM）粒上皇加盟热线（400—0205177转1），本公司从未授权其他平台、网站等进行招商代理。其他任何未经本公司授权的网站以“粒上皇”名义公布的加盟信息均为不实。
        </p>
        <p>
          2.粒上皇目前在“盟享加”（www.mxj.com.cn/brands/132852.html）有加盟业务的展示，但此信息主要为宣传展示，不涉及任何费用收取，加盟业务请以官方渠道沟通为准。
        </p>
        <p>
          针对以“粒上皇加盟”名义的一切非法活动，我们将通过法律维权并依法追究侵权人的法律责任。
        </p>
        <p>
          在此提醒投资者、创业者注意信息甄别，我公司在正式签约之前不会收取任何费用，对非官方渠道发布的加盟事宜产生的后果概不负责，请大家谨防上当受骗！如有任何疑问，可拨打粒上皇官方加盟热线电话（400—0205177转1）咨询。
        </p>
        <p>特此声明！</p>
        <div class="stamp">
          <p style="margin-bottom: 0px">广州粒上皇食品有限公司</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  watch: {
  },
  data () {
    return {
      dialogVisible: false
    };
  },
  created () {
    this.dialogVisible = true
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
.kingdom {
  .t_pic {
    width: 100%;
  }
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      padding-top: 40px;
      background: linear-gradient(
        177.32deg,
        rgba(255, 241, 165, 0.56) 0%,
        rgba(247, 192, 255, 0) 40.57%,
        rgba(163, 242, 255, 0) 100%
      );
    }
    .el-dialog__title {
      line-height: 38px;
      font-size: 26px;
    }
    .el-dialog__body {
      text-align: left;
      padding: 0px 30px 10px 30px;
      line-height: 30px;
      letter-spacing: 0.5px;
      p {
        text-indent: 2em;
        margin-bottom: 15px;
      }
      .stamp {
        text-align: right;
        margin-top: 30px;
        font-size: 14px;
        line-height: 1.8;
        color: #333;
      }
    }
  }
}
</style>
